<div class="dialog-wrapper">
  <p class="emoji-gift-cone">✌️</p>
  <h1 class="welcome-text">Good day!</h1>
  <p class="congrats-text">
    We found you have already connected your social accounts on our website. <br />
    Let's connect here to make your login experience better!
  </p>
  <ion-button expand="block" color="medium" class="capsule-btn" (click)="connect()"> Connect now </ion-button>
</div>